import React from 'react';
import { useSelector } from 'react-redux';
import LinearProgress from '@mui/material/LinearProgress';
import { Redirect } from 'react-router-dom';
import Helmet from 'react-helmet';

import { selectUser } from 'entities/user/selectors';
import { Privileges } from 'utils/privileges';
import { Features } from 'utils/features';
import { PayrollFlatFilePage, PayrollFlatFilePageV1 } from 'containers/PayrollFlatFilePage';
import { PayrollApiPage } from 'containers/PayrollApiPage';
import BackButtonLayoutTitleAction from 'retired/BackButtonLayout/BackButtonLayoutTitleAction';

const Layout = ({
  children,
  rightActions,
}: {
  children: React.ReactNode;
  rightActions?: React.ReactNode;
}) => (
  <BackButtonLayoutTitleAction to="/donations" title="Payroll" rightActions={rightActions}>
    <Helmet title="Payroll" />
    {children}
  </BackButtonLayoutTitleAction>
);

const PayrollGenericPage = (): JSX.Element => {
  const user = useSelector(selectUser);

  const payrollApiEnabled =
    user?.hasPrivilege(Privileges.DONATION_PAYROLL_VIEW) && user?.hasFeature(Features.PAYROLL_API);

  const payrollFlatFileEnabled =
    user?.hasPrivilege(Privileges.DONATION_PAYROLL_VIEW) &&
    user?.hasFeature(Features.PAYROLL_FLAT_FILE);

  const payrollFlatFileV2Enabled =
    payrollFlatFileEnabled && user?.organization.payrollFlatFile?.get('isNewDashboardEnabled');

  if (payrollFlatFileEnabled) {
    if (payrollFlatFileV2Enabled) {
      return <PayrollFlatFilePage />;
    }
    return <PayrollFlatFilePageV1 layout={Layout} />;
  }
  if (payrollApiEnabled) {
    return (
      <Layout>
        <PayrollApiPage />
      </Layout>
    );
  }

  return (
    <Layout>
      <LinearProgress />
      {!!user && <Redirect to="/" />}
    </Layout>
  );
};

export default PayrollGenericPage;
